export const PLAYBACK_SPEED_PRESETS = [0.75, 1, 1.25, 1.5, 2]
export const PLAYBACK_SPEED_MIN = 0.5
export const PLAYBACK_SPEED_MAX = 2
export const PLAYBACK_SPEED_STEP = 0.05

const STORAGE_KEY = 'lss-player-playback-speed'

export const normalizePlaybackSpeed = speed => {
  const value = Number(speed)
  const validValue = Number.isNaN(value) ? 1 : value
  const clampedValue = Math.min(
    PLAYBACK_SPEED_MAX,
    Math.max(PLAYBACK_SPEED_MIN, validValue)
  )
  return Number(
    (
      Math.round(clampedValue / PLAYBACK_SPEED_STEP) * PLAYBACK_SPEED_STEP
    ).toFixed(2)
  )
}

export const formatPlaybackSpeed = speed =>
  `${Number(normalizePlaybackSpeed(speed).toFixed(2))}×`

export const getStoredPlaybackSpeed = (fallback = 1) => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    return value === null
      ? normalizePlaybackSpeed(fallback)
      : normalizePlaybackSpeed(value)
  } catch (error) {
    return normalizePlaybackSpeed(fallback)
  }
}

export const savePlaybackSpeed = speed => {
  const value = normalizePlaybackSpeed(speed)
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value))
  } catch (error) {
    // 无痕模式或存储空间不可用时，倍速切换仍然可以正常使用。
  }
  return value
}

/**
 * 为百家云 BPlayer 的内置倍速菜单补充自定义速度控件。
 */
export const setupBPlayerCustomSpeed = (player, container) => {
  if (!player || typeof player.setSpeed !== 'function' || !container) {
    return
  }

  const speedControl = container.querySelector('.bplayer-speed-control')
  const speedList =
    speedControl && speedControl.querySelector('.bplayer-option-list')
  if (!speedList || speedList.querySelector('.bplayer-custom-speed')) {
    return
  }

  const normalOption = speedList.querySelector('[data-speed="1"]')
  if (normalOption) {
    normalOption.textContent = '正常'
    normalOption.setAttribute('data-label', '正常')
  }

  const customSpeed = document.createElement('li')
  customSpeed.className = 'bplayer-custom-speed'
  customSpeed.innerHTML = `
    <div class="bplayer-custom-speed-header">
      <span>自定义速度</span>
      <output class="bplayer-custom-speed-value" aria-live="polite"></output>
    </div>
    <div class="bplayer-custom-speed-controls">
      <button type="button" class="bplayer-custom-speed-minus" aria-label="降低播放速度">−</button>
      <input
        class="bplayer-custom-speed-range"
        type="range"
        min="${PLAYBACK_SPEED_MIN}"
        max="${PLAYBACK_SPEED_MAX}"
        step="${PLAYBACK_SPEED_STEP}"
        aria-label="自定义播放速度"
      />
      <button type="button" class="bplayer-custom-speed-plus" aria-label="提高播放速度">＋</button>
    </div>
  `
  speedList.appendChild(customSpeed)

  const valueOutput = customSpeed.querySelector(
    '.bplayer-custom-speed-value'
  )
  const rangeInput = customSpeed.querySelector('.bplayer-custom-speed-range')
  const minusButton = customSpeed.querySelector('.bplayer-custom-speed-minus')
  const plusButton = customSpeed.querySelector('.bplayer-custom-speed-plus')
  const currentSpeed = speedControl.querySelector('.bplayer-current-speed')

  const updateControl = speed => {
    const value = savePlaybackSpeed(speed)
    const formattedValue = formatPlaybackSpeed(value)
    rangeInput.value = value
    rangeInput.setAttribute('aria-valuetext', formattedValue)
    valueOutput.value = formattedValue
    if (currentSpeed) {
      currentSpeed.textContent = value === 1 ? '正常' : formattedValue
    }
  }

  const setSpeed = speed => {
    const value = normalizePlaybackSpeed(speed)
    player.setSpeed(value)
    updateControl(value)
  }

  customSpeed.addEventListener('click', event => event.stopPropagation())
  rangeInput.addEventListener('input', event => setSpeed(event.target.value))
  minusButton.addEventListener('click', () => {
    setSpeed(normalizePlaybackSpeed(player.speed) - PLAYBACK_SPEED_STEP)
  })
  plusButton.addEventListener('click', () => {
    setSpeed(normalizePlaybackSpeed(player.speed) + PLAYBACK_SPEED_STEP)
  })

  player.on('rate_change', updateControl)
  const initialSpeed = getStoredPlaybackSpeed(player.speed || 1)
  player.setSpeed(initialSpeed)
  updateControl(initialSpeed)
}
